export type ApiHandlerOptions = {
  throwOnError?: boolean;
};

export type ApiHandlerResult<TData> =
  | { ok: true; data: TData }
  | { ok: false; error: Error };

export type Handler<TArgObject, TData> = {
  (args: TArgObject, options: { throwOnError: true }): Promise<TData>;
  (
    args: TArgObject,
    options?: { throwOnError?: false },
  ): Promise<ApiHandlerResult<TData>>;
};

export const withSafeApi = <TArgObject, TData>(
  apiCallback: (args: TArgObject) => TData | Promise<TData>,
): Handler<TArgObject, TData> => {
  const handler = async (
    args: TArgObject,
    options?: ApiHandlerOptions,
  ): Promise<TData | ApiHandlerResult<TData>> => {
    try {
      const data = await apiCallback(args);
      if (options?.throwOnError) return data;
      return { ok: true, data };
    } catch (error: unknown) {
      const err = error instanceof Error ? error : new Error('Unknown error');
      if (options?.throwOnError) throw err;
      return { ok: false, error: err };
    }
  };

  return handler as Handler<TArgObject, TData>;
};
